import React, { useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const SignatureForm = ({ company, onSubmit, currentSignature, isSaving }: any) => {
    const [showPassword, setShowPassword] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      signatureFile: null,
      password: "",
    },
    validationSchema: Yup.object({
      signatureFile: Yup.mixed().required("El archivo de la firma es requerido."),
      password: Yup.string().required("La contraseña es requerida."),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("companyId", company.id);
      formData.append("password", values.password);
      if (values.signatureFile) {
        formData.append("file", values.signatureFile);
      }
      onSubmit(formData, resetForm);
    },
  });

  return (
    <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
      <p>Sube el archivo de la firma electrónica (.p12) y su contraseña.</p>

      {currentSignature && (
        <div className="alert alert-info">
          <strong>Firma actual:</strong> {currentSignature.filePath ? currentSignature.filePath.split('/').pop() : "Firma registrada"}
          <br />
          <small>Vence: {currentSignature.expirationDate ? new Date(currentSignature.expirationDate).toLocaleDateString() : "N/A"}</small>
        </div>
      )}

        <FormGroup>
            <Label for="signatureFile">Archivo de Firma (.p12)</Label>
            <Input
                id="signatureFile"
                type="file"
                name="signatureFile"
                accept=".p12"
                onChange={(event) => {
                    const file = event.currentTarget.files ? event.currentTarget.files[0] : null;
                    validation.setFieldValue("signatureFile", file);
                }}
                invalid={!!validation.touched.signatureFile && !!validation.errors.signatureFile}
            />
            {validation.touched.signatureFile && validation.errors.signatureFile ? (
                <FormFeedback>{validation.errors.signatureFile as string}</FormFeedback>
            ) : null}
        </FormGroup>
        <FormGroup>
            <Label>Contraseña de la Firma</Label>
            <div className="input-group">
                <Input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Ingrese la contraseña"
                    value={validation.values.password}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={!!validation.touched.password && !!validation.errors.password}
                />
                <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                >
                    <i className={showPassword ? "las la-eye-slash" : "las la-eye"}></i>
                </button>

                {validation.touched.password && validation.errors.password ? (
                    <FormFeedback>{validation.errors.password}</FormFeedback>
                ) : null}
            </div>
        </FormGroup>
        <Button
          color="primary"
          className="waves-effect waves-light float-end"
          type="submit"
          disabled={isSaving}
        >
          {isSaving ? (
            <>
              <Spinner size="sm" className="me-2" />
              Guardando...
            </>
          ) : (
            <>
              <i className="ri-save-line label-icon align-middle fs-16 me-2"></i>
              Guardar Firma
            </>
          )}
        </Button>
    </Form>
  );
};

export default SignatureForm;
